module.exports = __webpack_public_path__ + "img/noopen.3a78b552.png";